<template>
  <mks-button 
    v-if="topic && topicId"
    :class="{'like-topic-button': true, 'like-topic-button--liked': topicIsLiked}"
    :type="color"
    :icon="icon"
    :icon-right="showIconOnRight"
    :disabled="loading"
    @click="likeTopic"
  >
    <slot>
    </slot>
  </mks-button>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: {
    topic: {
      type: Object
    },
    color: {
      type: String,
      default: 'atlantis'
    },
    icon: {
      type: String,
      default: 'heart'
    },
    showIconOnRight: {
      type: Boolean,
      default: true
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('user', ['profile']),
    topicId() {
      if (this.topic._id) return this.topic._id;
      else return this.topic.id;
    },
    topicIsLiked() {
      if (this.profile && this.profile.topic && this.topicId) return this.profile.topic.includes(this.topicId);
      return false;
    }
  },
  methods: {
    ...mapActions({
      storeUpdateUser: "user/updateUser",
    }),
    async likeTopic() {
      this.$store.dispatch("analytics/track", {
            event: "Makesense Chiche - Like topic not loggedin",
            data: {
              topic: this.topic.title,
              topicId: this.topicId
            }
          });
      if (!this.profile) {
        console.log('NO PROFILE');
        this.$store.dispatch('flowLoginRegister/start', {
          source: 'like',
          feature: 'like-topic',
          callback: this.likeTopic // tester si le user a déjà liké dans le callback
        });
        // todo: if user not logged in-> lancer flow de login
        // ou cacher le bouton en attendant
      }
      else {
        console.log('has profile');
        this.loading = true;
        let res;
        let liking;

        if (!this.topicIsLiked) {
          liking = true;
          const topics = [...this.profile.topic];
          topics.push(this.topicId);
          res = await this.storeUpdateUser({topic: topics});
          this.$store.dispatch("analytics/track", {
            event: "Makesense Chiche - Like topic",
            data: {
              topic: this.topic.title,
              topicId: this.topicId
            }
          });
        }
        else {
          let topics = [...this.profile.topic];
          topics = topics.filter(i => i !== this.topicId);
          res = await this.storeUpdateUser({topic: topics});
          this.$store.dispatch("analytics/track", {
            event: "Makesense Chiche - Remove like topic",
            data: {
              topic: this.topic.title,
              topicId: this.topicId
            }
          });
        } 

        if (res === true) {
          let message;
          let type;
          if (liking) {
            message = "Ton centre d'intérêt à bien été enregistré";
            type = 'success';
          } else {
            message = "Ton centre d'intérêt à bien été supprimé"
            type = 'default'
          }

          this.$toasted.show(message, {
              position: "bottom-center",
              duration: 4000,
              type,
          });
        } else {
          // error
          message = this.__("Une erreur s'est produite lors de l'enregistrement de ton centre d'intérêt");
          this.$toasted.show(message, {
              position: "bottom-center",
              duration: 8000,
              type: "error",
          });
        }
        this.loading = false;

        if (this.callback) this.callback();
      }
      
    }
  }
}
</script>
<style lang="scss" scoped>
.like-topic-button--liked :deep(){
  .icon {
    fill: $color-primary;
  }
}
</style>